/* RESPONSIBLE TEAM: team-automation-foundations */
import GuidanceController from 'embercom/controllers/apps/app/automation/fin-ai-agent/guidance';

export default class AutomationFinAIAgentEcommerceGuidanceController extends GuidanceController {}
